import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMailBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m21.499 15.107.001-.007V8.9l-.001-.005c0-.303-.032-.593-.078-.877a6 6 0 0 0-.108-.555l-.008-.045-.004.003a5.6 5.6 0 0 0-.574-1.468l.007-.006-.038-.056c-.048-.083-.103-.16-.156-.239a5 5 0 0 0-.414-.547c-.045-.052-.086-.107-.133-.156a5 5 0 0 0-.647-.575q-.076-.053-.151-.104a5 5 0 0 0-.732-.422q-.03-.014-.057-.029a5 5 0 0 0-.862-.279q-.1-.023-.203-.042a5 5 0 0 0-.931-.097H7.59a5.3 5.3 0 0 0-1.095.126c-1.416.304-2.564 1.181-3.259 2.435l.023.018a5.7 5.7 0 0 0-.569 1.467l-.009-.007c-.009.04-.014.083-.023.124q-.045.205-.077.418A6 6 0 0 0 2.5 8.9v6.204c0 .336.036.658.09.972.037.234.095.456.157.68q.01.048.022.095l.004-.004c.265.91.706 1.734 1.327 2.354.562.562 1.252.946 2.023 1.172q.141.047.285.083.178.042.362.07c.265.043.536.073.817.074l.013.001h8.81c.314 0 .615-.037.909-.088l.064-.012a4.8 4.8 0 0 0 2.455-1.252c.02-.018.042-.03.062-.048.036-.036.062-.084.097-.12.21-.223.407-.458.577-.719l-.001-.002c.29-.45.494-.967.652-1.507l.012.013c.022-.078.033-.162.053-.24.043-.173.088-.34.116-.518a6 6 0 0 0 .093-1"
      clipRule="evenodd"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m19.495 17.188-4.351-4.731-.52.425a4 4 0 0 1-2.572.915 4.03 4.03 0 0 1-2.582-.92l-.577-.462-4.39 4.768a4.6 4.6 0 0 1-.469-1.706l3.685-4.002-3.687-2.952c.046-.58.19-1.113.421-1.585l5.966 4.778c.935.779 2.328.778 3.251.009l5.87-4.801c.234.473.38 1.008.427 1.589l-3.66 2.993 3.658 3.978a4.6 4.6 0 0 1-.47 1.704"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMailBulk);
export default ForwardRef;
